import { useDeleteProjectMutation } from '@consigli/hooks';
import { useCallback, useState } from 'react';

import { successToast, errorToast } from '@/components/toast';

interface ProjectToDelete {
  id: number;
  name: string;
}

export const useDeleteProject = () => {
  const [deleteProject, { isLoading: isDeleting }] = useDeleteProjectMutation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState<ProjectToDelete | null>(null);

  const handleDeleteClick = useCallback((projectId: number, projectName: string) => {
    setProjectToDelete({ id: projectId, name: projectName });
    setIsModalOpen(true);
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    if (!projectToDelete) return;

    try {
      await deleteProject({ projectId: projectToDelete.id }).unwrap();
      successToast({ message: `Project "${projectToDelete.name}" has been deleted successfully` });
      setIsModalOpen(false);
      setProjectToDelete(null);
      // The table will automatically refresh due to the query invalidation
    } catch (error) {
      console.error('Failed to delete project:', error);
      errorToast({ message: 'Failed to delete project. Please try again.' });
    }
  }, [deleteProject, projectToDelete]);

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false);
    setProjectToDelete(null);
  }, []);

  return {
    isModalOpen,
    projectToDelete,
    isDeleting,
    handleDeleteClick,
    handleConfirmDelete,
    handleCloseModal,
  };
};
